import breakpoints from './breakpoints.scss';

import React from 'react';
import MediaQuery, { MediaQueryProps } from 'react-responsive';

// Types copied from redux-responsive
export type BreakPointsDefaultNames =
  | 'mobile'
  | 'tablet'
  | 'desktop'
  | 'desktopLarge';

export type IBreakPoints<BPNames extends string = BreakPointsDefaultNames> = {
  [k in BPNames]: number | string
};

export type IBreakPointResults<BP = IBreakPoints> = { [k in keyof BP]: boolean };

export interface IBrowser<BP = IBreakPoints> {
  lessThan: IBreakPointResults<BP>;
  greaterThan: IBreakPointResults<BP>;
  is: IBreakPointResults<BP>;
}

export const browserBreakpoints = {
  mobile: parseInt(breakpoints.mobileMaxPx),
  tablet: parseInt(breakpoints.tabletMaxPx),
  desktop: parseInt(breakpoints.desktopMaxPx),
};

export type BrowserBreakpoints = IBrowser<typeof browserBreakpoints>;

export const Mobile: React.FC<MediaQueryProps> = props => (
  <MediaQuery maxWidth={browserBreakpoints.mobile} {...props} />
);

export const Tablet: React.FC<MediaQueryProps> = props => (
  <MediaQuery minWidth={browserBreakpoints.mobile + 1} maxWidth={browserBreakpoints.tablet} {...props} />
);

export const Desktop: React.FC<MediaQueryProps> = props => (
  <MediaQuery minWidth={browserBreakpoints.tablet + 1} maxWidth={browserBreakpoints.desktop} {...props} />
);

export const DesktopLarge: React.FC<MediaQueryProps> = props => (
  <MediaQuery minWidth={browserBreakpoints.desktop + 1} {...props} />
);
